import { Accordion, AccordionSummary, Typography, AccordionDetails } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { RuleGroupType, RuleType, Field, Classname } from "react-querybuilder"
import { RuleSetMetadataEntry } from "../types/ruleSetTypes"
import RuleSetQueryBuilder from "./RuleSetQueryBuilder"

export function RuleSetAccordion(props: {
  title: string,
  color: string,
  ruleGroup: RuleGroupType,
  metadata: RuleSetMetadataEntry[],
  readonly: boolean,
  onQueryChange?: (query: RuleGroupType) => void,
  getRuleClassname?: (rule: RuleType, misc: { fieldData: Field } ) => Classname,
  getRuleGroupClassname?: (ruleGroup: RuleGroupType) => Classname
}) {

return (
  <Accordion defaultExpanded={true}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="h6" fontWeight="bold" color={props.color}>{props.title}</Typography>
    </AccordionSummary>
    <AccordionDetails>
    <div >
      <RuleSetQueryBuilder
        metadata={props.metadata}
        defaultQuery={props.ruleGroup}
        readonly={props.readonly}
        onQueryChange={props.onQueryChange}
        getRuleClassname={props.getRuleClassname}
        getRuleGroupClassname={props.getRuleGroupClassname}
      />
    </div>
    </AccordionDetails>
  </Accordion>
)
}